import { Link, useLocation } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { NodeStatusPill } from "@/components/NodeStatusPill";

const NAV = [
    { label: "Live engine", to: "/live" },
    { label: "Bond transfer", to: "/request/TX-BOND-001" },
    { label: "Freeze review", to: "/request/TX-BOND-002" },
    { label: "Corporate action", to: "/request/CA-ELEC-001" },
    { label: "Structured data", to: "/standards" },
    { label: "Enforcement", to: "/enforcement" },
    { label: "Plain English", to: "/explained" },
];

export const Layout = ({ children, wide = false }) => {
    const { pathname } = useLocation();
    return (
        <div className="flex min-h-screen flex-col bg-slate-50">
            <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur">
                <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3.5">
                    <Brand />
                    <nav className="hidden items-center gap-1 md:flex">
                        {NAV.map((n) => (
                            <Link
                                key={n.to}
                                to={n.to}
                                data-testid={`nav-${n.to.replace(/\//g, "-")}`}
                                className={`rounded-sm px-3 py-1.5 text-sm transition-colors duration-150 ${
                                    pathname === n.to
                                        ? "bg-slate-100 text-slate-900"
                                        : "text-slate-500 hover:bg-slate-50 hover:text-slate-900"
                                }`}
                            >
                                {n.label}
                            </Link>
                        ))}
                    </nav>
                </div>
            </header>

            <main className={`mx-auto w-full flex-1 px-6 py-10 ${wide ? "max-w-6xl" : "max-w-6xl"}`}>
                {children}
            </main>

            <footer className="border-t border-slate-200 bg-white">
                <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 py-6 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between">
                    <p className="max-w-xl leading-relaxed">
                        Synthetic standards-oriented sandbox. No real financial assets,
                        custody, settlement or customer data. Not a regulatory or
                        compliance certification.
                    </p>
                    <div className="flex items-center gap-4">
                        <Link
                            to="/diagnostics"
                            data-testid="footer-diagnostics-link"
                            className="font-mono text-slate-400 hover:text-slate-700"
                        >
                            Diagnostics
                        </Link>
                        <NodeStatusPill />
                    </div>
                </div>
            </footer>
        </div>
    );
};
